<template>
  <form @submit.prevent="">
    <Field
      label="Domain Name"
      @input="$v.resource.domain.$touch()"
      @handleChange="handleChange"
      v-model="resource.domain"
      preText="www."
      helpText="Do not include <strong>https://</strong> when entering your domain name"
      placeholder="example.com"/>

    <div class="btn-save">
      <Btn
        @click="submit"
        :disabled="$v.$invalid"
        :class="{'changes-made': changesMade}">
        Save Changes
      </Btn>
    </div>
  </form>
</template>

<script>
import form from '@/mixins/form'

import Btn from '@/components/Btn'

import {errorMessages} from '@/lib/error_messages'
import {required} from 'vuelidate/lib/validators'

export default {
  name: 'SiteDomainForm',

  mixins: [form],

  components: {
    Btn
  },

  computed: {
    ...errorMessages([
      'domain'
    ])
  },

  validations: {
    resource: {
      domain: {required}
    }
  }
}
</script>
